"use client";
import React, { useEffect, Suspense } from "react";
import { useSearchParams } from "next/navigation";

import "./styles.scss";

interface ParameterSetBoxProps {
  className?: string;
}

// 内部组件，处理 useSearchParams
const ParameterSetBoxInner: React.FC<ParameterSetBoxProps> = ({ className = "" }) => {
  const searchParams = useSearchParams();

  useEffect(() => {
    console.log("ParameterSetBox");

    // Parse URL parameters
    const urlParams = new URLSearchParams(searchParams.toString());
    const allParams: Record<string, string> = {};

    // Extract all parameters
    urlParams.forEach((value, key) => {
      allParams[key] = value;
    });

    console.log("URL Parameters:", allParams);

    // Example: Parse specific parameter like utm_source
    const utmSource = searchParams.get("utm_source");
    if (utmSource) {
      console.log("UTM Source:", utmSource);
      localStorage.setItem("utm_source", utmSource);
    }

    // // Example: Parse utm_medium, utm_campaign, etc.
    // const utmMedium = searchParams.get("utm_medium");
    // const utmCampaign = searchParams.get("utm_campaign");
    // const utmTerm = searchParams.get("utm_term");
    // const utmContent = searchParams.get("utm_content");

    // if (utmMedium) console.log("UTM Medium:", utmMedium);
    // if (utmCampaign) console.log("UTM Campaign:", utmCampaign);
    // if (utmTerm) console.log("UTM Term:", utmTerm);
    // if (utmContent) console.log("UTM Content:", utmContent);
  }, [searchParams]);

  return <></>;
};

// 主组件，使用 Suspense 包装
export default function ParameterSetBox(props: ParameterSetBoxProps) {
  return (
    <Suspense fallback={<></>}>
      <ParameterSetBoxInner {...props} />
    </Suspense>
  );
}
